<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-link-variant</v-icon> Slug
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-text-field
        outlined
        label="Slug"
        v-model="slug"
        messages="No caratteri speciali, esempio: apostrofi, virgole, lettere accentate ecc.."
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ArticleSlug',
    data() {
      return {
        slug: '',
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      slug(val) {
        this.$store.commit('SET_ARTICLE_SLUG', val)
      },
      newArticle: {
        handler(val) {
          this.slug = val.slug
        },
        deep: true
      }
    },
    created() {
      this.slug = this.newArticle.slug || ''
    }
  }
</script>